module.exports = __webpack_public_path__ + "./kuan_71ff326d2a0ca7b7479bb0f59447d61f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/kuan.png
// module id = 425
// module chunks = 0